import React from "react";
import {
  countObjectUseCase,
  deleteObjectUseCase,
  findObjectUseCase,
  upsertUseCase,
} from "../../../usecases/object";
import withRouter from "../../../withRouter";
import BaseListPage from "../../../base/BaseListPage";
import { InfiniteScroll, Button } from "nq-component";
import Search from "../../../components/Search";
import Table from "../../../components/Table";
import CardView from "../../../components/common/CardView";
import PayrollSetupPresenter from "./ItemOptionsPresenter";

class ItemOptionsPage extends BaseListPage {
  constructor(props) {
    super(props);
    this.state = {
      objects: [],
      limit: 50,
      current: 1,
      count: 0,
    };
    this.presenter = new PayrollSetupPresenter(
      this,
      findObjectUseCase(),
      countObjectUseCase(),
      deleteObjectUseCase(),
      upsertUseCase()
    );
  }

  getCollectionName() {
    return "item_options";
  }

  onClickPagination(page) {
    this.presenter.setCurrentPage(page);
  }

  setObjects(objects) {
    this.setState({ objects });
  }

  setCurrent(current) {
    this.setState({ current });
  }

  async _createPayrollSetups() {
    this.navigateTo(`/form/${this.getCollectionName()}`);
  }

  async _handleDeleteData(id) {
    await this.presenter.deleteObjectUseCase.execute("item_options", id);
    this.refetchData();
  }

  async handleEditData(id) {
    this.navigateTo(`/form/${this.getCollectionName()}/${id}`);
    // this.refetchData();
  }

  async refetchData() {
    const objects = await this.presenter.getObjects();
    this.filterSubmit({});
    return objects;
  }

  render() {
    const { objects, loading, count, limit, current } = this.state;
    const schema = this.getSchema(this.getCollectionName());
    if (!schema) return <h1>no schema</h1>;

    return (
      <>
        <div className="overflow-auto" style={{ marginTop: "5rem" }}>
          <InfiniteScroll className="h-100" loadMore={this.loadMore.bind(this)}>
            <div className="p-3 p-lg-4">
              <div
                className="d-flex mb-4"
                style={{ borderBottom: "1.5px solid #d3d3d3" }}
              >
                <p style={{ fontSize: ".9rem", color: "rgba(0, 0, 0, .45)" }}>
                  You are here: Home {">"} Reference Tables {">"}{" "}
                  <span
                    style={{ fontSize: "1rem", color: "rgba(0, 0, 0, .70)" }}
                  >
                    {schema.label}
                  </span>
                </p>
              </div>
              <CardView style={{ borderRadius: 0 }}>
                <Search
                  schemas={this.getSchemas()}
                  onSubmit={this.searchSubmit.bind(this)}
                  fields={schema.fields}
                />
              </CardView>
              <div
                style={{
                  marginTop: "20px",
                  width: "100%",
                }}
              >
                <CardView style={{ borderRadius: 0 }}>
                  <div className="d-flex align-items-center  justify-content-center">
                    <h4 className="text-primary">{schema.label}</h4>
                    <div
                      className="d-flex gap-2"
                      style={{ marginLeft: "auto" }}
                    >
                      <Button onClick={this._createPayrollSetups.bind(this)}>
                        <i className="bi bi-plus-lg" /> Create
                      </Button>
                    </div>
                  </div>
                </CardView>
              </div>

              <Table
                objectId={this._handleDeleteData.bind(this)}
                editId={this.handleEditData.bind(this)}
                progress={loading}
                refetch={this.refetchData.bind(this)}
                fields={schema.fields}
                objects={objects}
                collection={schema}
                count={count}
                limit={limit}
                current={current}
                loadPagination={this.onClickPagination.bind(this)}
                actionsList={[
                  {
                    label: <i className="bi bi-three-dots-vertical" />,
                    actionType: "common",
                  },
                ]}
                excludeFields={Object.keys(schema.fields).reduce(
                  (acc, key) => {
                    const options = schema.fields[key];
                    if (options.read === false) {
                      acc.push(key);
                    }
                    switch (options._type || options.type) {
                      case "Relation":
                      // case "Array":
                      case "Object":
                      case "File":
                        acc.push(key);
                        break;
                      default:
                    }
                    return acc;
                  },
                  ["id", "Created At", "Updated At"]
                )}
              />
            </div>
          </InfiniteScroll>
        </div>
      </>
    );
  }
}

export default withRouter(ItemOptionsPage);
